<template>
    <div class="course__edit_feedback_form">
        <template v-if="isRouteCatalogItem">
            <template v-if="!workspaceFeedbackFormsEnabled">
                <component-note
                    :class="'course__edit_feedback_form_disablednote'"
                >Feedback forms are not enabled in this workspace.</component-note>
            </template>
            <component-wrapper
                :class="'course__edit_feedback_form_catalogitem_wrapper course__edit_feedback_form_catalogitem_wrapper--custom'"
            >
                <form-radio
                    :class="'course__edit_feedback_form_catalogitem_radio course__edit_feedback_form_catalogitem_radio--custom'"
                    :label="''"
                    :name="'lms-superadmin-workspace-edit-feedbackforms-radio-custom'"
                    :items="[
                        {
                            name: 'Use default template',
                            value: 'workspaceDefault'
                        }
                    ]"
                    :value="catalogItemFeedbackForm"
                    @input="setCatalogItemFeedbackForm('workspaceDefault')"
                >Default: {{ workspaceFeedbackFormDefault ? workspaceFeedbackFormDefault.name : '' }}
                </form-radio>
            </component-wrapper>
            <form-radio
                :class="'course__edit_feedback_form_catalogitem_radio course__edit_feedback_form_catalogitem_radio--selected'"
                :label="''"
                :name="'course-edit-feedbackform-catalogitem-radio-selected'"
                :items="[
                    {
                        name: 'Use other template',
                        value: 'selected'
                    }
                ]"
                :value="catalogItemFeedbackForm !== null && catalogItemFeedbackForm !== 'workspaceDefault' ? 'selected' : catalogItemFeedbackForm"
                @input="setCatalogItemFeedbackForm('selected')"
            />
            <template v-if="catalogItemFeedbackForm !== null && catalogItemFeedbackForm !== 'workspaceDefault'">
                <component-wrapper
                    :class="'course__edit_feedback_form_catalogitem_wrapper course__edit_feedback_form_catalogitem_wrapper--selected'"
                >
                    <form-select
                        ref="selectfeedbackforms"
                        :disabled="!loggedInWorkspaceId"
                        :class="'course__edit_feedback_form_catalogitem_feedback_form'"
                        :data-vv-as="'feedback form'"
                        :get-items-getter="'getLmsSuperadminWorkspaceFeedbackFormsMappedIdNameStatus'"
                        :get-items-getter-mapped="'getLmsSuperadminWorkspaceFeedbackFormsMappedLabelValue'"
                        :get-items-dispatch="'lmsSuperadminWorkspaceFeedbackFormsGet'"
                        :get-items-dispatch-data="{ workspaceId: loggedInWorkspaceId }"
                        :item-name="['feedback form', 'feedback forms']"
                        :label="''"
                        :name="'course-edit-feedbackform-catalogitem-feedbackform'"
                        :table-labels="[
                            {
                                key: 'name',
                                title: 'Name',
                                type: 'string'
                            }
                        ]"
                        :advanced-search-active="true"
                        :value="catalogItemFeedbackForm"
                        @input="setCatalogItemFeedbackForm"
                        @input-table="setCatalogItemFeedbackForm"
                    ></form-select>
                </component-wrapper>
            </template>
            <form-radio
                :class="'course__edit_feedback_form_catalogitem_radio course__edit_feedback_form_catalogitem_radio--disable'"
                :label="''"
                :name="'course-edit-feedbackform-catalogitem-radio-selected'"
                :items="[
                    {
                        name: 'None',
                        value: null
                    }
                ]"
                :prevent="true"
                :value="catalogItemFeedbackForm"
                @emit-prevent="openSetNoneFeedbackFormsNotify"
            >
            </form-radio>
            <template v-if="workspaceFeedbackFormSelected && workspaceFeedbackFormSelected.fields && workspaceFeedbackFormSelected.fields.length">
                <form-customform
                    :title="workspaceFeedbackFormSelected.name"
                    :name="'course-edit-feedbackform-catalogitem-preview'"
                    :actions-active="false"
                    :items="workspaceFeedbackFormSelected.fields"
                ></form-customform>
            </template>
            <component-button
                :name="'course-edit-feedbackform-catalogitem-create'"
                :theme="'default'"
                :align="'right'"
                :to="{
                    name: 'ebs-catalog-item-edit-feedback-forms-add',
                    params: { courseId: originCourseId, catalogId: originCatalogId, versionId: originVersionId }
                }"
            >Create new form
            </component-button>
            <pop-notify
                ref="notifynonefeedbackforms"
                :class="'pop__notify--remove'"
                :title-text="'No feedback form required?'"
                :content-text="`Not having a feedback forms for this course means learners will not have to give feedback to complete the course.\n\nLearners who are in progress or have finished the modules of this course, will not have to give feedback to complete the course.\n\nAre you sure you want to remove the feedback form for the course?`"
                :cancel-button-text="'Cancel'"
                :submit-button-text="'Remove'"
                :size="'medium'"
                :prevent-close="true"
                :submit-button-animate-loading="true"
                :submit-button-animate-loading-name="'enable-feedback-forms'"
                @emit-submit="setCatalogItemFeedbackForm(null)"
            />
        </template>
    </div>
</template>

<script>

import { validateBeforeRouteLeave, watchContentChangeEmit } from '@/helpers/mixins'
import ComponentWrapper from '@/components/default/shared/ComponentWrapper'
import FormRadio from '@/components/default/forms/FormRadio'
import ComponentButton from '@/components/default/shared/ComponentButton'
import FormSelect from '@/components/default/forms/FormSelect'
import ComponentNote from '@/components/default/shared/ComponentNote'
import FormCustomform from '@/components/default/forms/FormCustomform'
import PopNotify from '@/components/default/shared/PopNotify'

export default {
  name: 'course-edit-feedbackForm',
  components: { PopNotify, FormCustomform, ComponentNote, FormSelect, ComponentButton, FormRadio, ComponentWrapper },
  data () {
    return {
      requestPending: false
    }
  },
  mixins: [validateBeforeRouteLeave, watchContentChangeEmit],
  computed: {
    catalogItemFeedbackForm () {
      return this.$store.getters.getEbsCatalogItemFeedbackForm
    },
    workspaceFeedbackForms () {
      return this.$store.getters.getLmsSuperadminWorkspaceFeedbackFormsData
    },
    workspaceFeedbackFormsEnabled () {
      return this.$store.getters.getLmsSuperadminWorkspaceFeedbackFormsEnabled
    },
    workspaceFeedbackFormDefault () {
      return this.$store.getters.getLmsSuperadminWorkspaceFeedbackFormsDefault
    },
    workspaceFeedbackFormSelected () {
      const feedbackForm = this.$store.getters.getLmsSuperadminWorkspaceFeedbackFormsById(this.catalogItemFeedbackForm)
      return feedbackForm || {}
    },
    feedbackForms () {
      const getterName = this.isRouteCourse ? 'getEbsCourseFeedbackForm' : 'getEbsCatalogItemFeedbackForm'
      return this.$store.getters[getterName].definition
    },
    rootItemName () {
      return 'course'
    },
    //
    isAddMode () {
      return this.$route.name.includes('-add')
    },
    isEditMode () {
      return this.$route.name.includes('-edit')
    },
    isShowMode () {
      return this.$route.name.includes('-show')
    },
    isRouteCourse () {
      return this.$route.name.includes('ebs-course-edit') || this.$route.name.includes('ebs-course-add')
    },
    isRouteCatalogItem () {
      return this.$route.name.includes('ebs-catalog-item-edit')
    },
    originCourseId () {
      return this.$route.params.courseId
    },
    originCatalogId () {
      return this.$route.params.catalogId
    },
    originVersionId () {
      return this.$route.params.versionId
    },
    loggedInWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    courseWorkspaceSettingsWorkspaces () {
      return this.$store.getters.getEbsCatalogItemWorkspacesSettings
    }
  },
  methods: {
    setCatalogItemFeedbackForm (value) {
      const outputValue = value && value.constructor === Object ? value.value : value
      this.$store.dispatch('ebsCatalogItemFeedbackFormSet', outputValue)
      if (value === null) {
        this.closeSetNoneFeedbackFormsNotify()
      }
    },
    openSetNoneFeedbackFormsNotify () {
      this.$refs.notifynonefeedbackforms.openNotify()
    },
    closeSetNoneFeedbackFormsNotify () {
      this.$refs.notifynonefeedbackforms.closeNotify()
    },
    getCourseWorkspaceSettings () {
      this.requestPending = true
      const catalogId = this.$route.params.catalogId
      this.$store.dispatch('ebsCatalogItemGetWorkspaceSettings', catalogId).finally(() => {
        this.requestPending = false
        this.$eventBus.$emit('stop-loading')
      })
    },
    getWorkspaceFeedbackForms () {
      return this.$store.dispatch('lmsSuperadminWorkspaceFeedbackFormsGet', { requestData: { workspaceId: this.loggedInWorkspaceId } })
    },
    clearWorkspaceFeedbackForm () {
      this.$store.dispatch('lmsSuperadminWorkspaceFeedbackFormClear')
    }
  },
  created () {
    const routeFeedbackFormId = this.$route.query.feedbackFormId
    if (this.isRouteCatalogItem && !this.courseWorkspaceSettingsWorkspaces.length) {
      this.getCourseWorkspaceSettings()
    }
    if (!this.workspaceFeedbackForms.length) {
      this.getWorkspaceFeedbackForms()
    }
    if (routeFeedbackFormId) {
      this.setCatalogItemFeedbackForm(routeFeedbackFormId)
    }
    this.clearWorkspaceFeedbackForm()
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/courses/courseaddeditfeedbackform";
</style>
